// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import * as React from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import { de } from "date-fns/locale";

function MemberItem(props) {
  const {
    firstname,
    lastname,
    positions,
    rank,
    city,
    entryDate,
    portraitHref,
    email,
    phoneNr,
  } = props.memberData;
  const dgrdStyle = {
    width: "48px",
    height: "48px",
    position: "relative",
    marginTop: 80,
    marginLeft: -40,
  };
  return (
    <Grid
      item
      xs={12}
      md={6}>
      <Card
        sx={(theme) => ({
          alignItems: "center",
          height: "100%",
          [theme.breakpoints.down("sm")]: {
            display: "grid",
          },
          [theme.breakpoints.up("sm")]: {
            display: "flex",
          },
        })}>
        <Box sx={{ display: "flex", justifyContent: "center", marginLeft: 2 }}>
          <Avatar
            alt={firstname.substring(0, 1) + lastname.substring(0, 1)}
            src={process.env.PUBLIC_URL + portraitHref}
            sx={{ height: "120px", width: "80px" }}
          />
          {typeof rank !== "undefined" ? (
            <img
              src={
                process.env.PUBLIC_URL +
                "/dgrd/" +
                rank.toLowerCase() +
                ".noe.png"
              }
              alt={rank}
              style={dgrdStyle}
            />
          ) : (
            ""
          )}
        </Box>
        <Box>
          <CardContent>
            <Typography variant="h6">{firstname + " " + lastname}</Typography>
            {typeof positions !== "undefined" && positions.length >= 1 && (
              <Typography variant="subtitle1">{positions[0]}</Typography>
            )}
            {typeof phoneNr !== "undefined" && (
              <Typography variant="subtitle1">Telefon: {phoneNr}</Typography>
            )}
            {typeof email !== "undefined" && (
              <Typography variant="subtitle1">Email: {email}</Typography>
            )}
            {typeof entryDate !== "undefined" && (
              <Typography variant="subtitle1">
                Beitritt: {format(entryDate, "dd. MMMM yyyy", { locale: de })}
              </Typography>
            )}
            <Typography variant="subtitle1">Ort: {city}</Typography>
            {typeof positions !== "undefined" && positions.length > 1 && (
              <>
                <Typography variant="subtitle1">Weitere Positionen:</Typography>
                <ul>
                  {positions.map(function (position, i) {
                    if (i > 0) {
                      return (
                        <li key={`Key${i}`}>
                          <Typography variant="body1">{position}</Typography>
                        </li>
                      );
                    } else {
                      return null;
                    }
                  })}
                </ul>
              </>
            )}
          </CardContent>
        </Box>
      </Card>
    </Grid>
  );
}

export default MemberItem;
